import { InfoCircle } from "@reverb-ui/icons-react";
import { HStack, Text, Tooltip } from "@reverb-ui/react";
import { ViewPortSizeVariationEnum } from "domain/entities/view-port-ranking-response";

type TViewPortSize = {
  tooltipMessage: ViewPortSizeVariationEnum;
  children: string;
};

const VIEW_PORT_SIZE_MESSAGE = {
  [ViewPortSizeVariationEnum.XS]: "Less than 768px wide",
  [ViewPortSizeVariationEnum.SM]: "From 768px to 991px wide",
  [ViewPortSizeVariationEnum.MD]: "From 992px to 1999px wide",
  [ViewPortSizeVariationEnum.LG]: "At least 1200px wide",
  [ViewPortSizeVariationEnum.UK]: "Unknown"
};

export const ViewPortSizeCell = ({
  tooltipMessage,
  children,
}: TViewPortSize) => (
  <HStack spacing={3}>
    <Text fontSize="sm" color="gray.700">
      {children}
    </Text>
    <Tooltip
      label={VIEW_PORT_SIZE_MESSAGE[tooltipMessage]}
      bg="gray.100"
      color="gray.800"
      shouldWrapChildren
    >
      <InfoCircle size="md" color="gray.500" />
    </Tooltip>
  </HStack>
);
